import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../utils/tpoGenQueryKeys';
import { sendNotification } from 'utils/helperMethods';

export interface CreatePlanPayload {
    plan_name: string;
    dim1_attrs: string[];
    dim2_attrs: string[];
    plan_year: number;
    plan_version: string;
    baseline_vol_version?: string;
    [key: string]: unknown;
}

const createPlan = async (payload: CreatePlanPayload) => {
    const token = localStorage.getItem('accessToken');
    const response = await axios(tpoGenUrls.createPlan, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: {
            ...payload,
            created_by: localStorage.getItem('email'),
        },
    });

    if (response?.data?.plan_creation_status === 'failed') {
        throw new Error(response?.data?.error_message);
    }

    return response.data;
};

const useCreatePlanMutation = ({ onSuccess }: { onSuccess?: () => void }) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: (payload: CreatePlanPayload) => createPlan(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.planningGroups() });
            queryClient.removeQueries({ queryKey: [...tpoGenKeys.all, 'plan-list'] });
            queryClient.invalidateQueries({ queryKey: [...tpoGenKeys.all, 'importable-plans'] });
            sendNotification('success', 'Plan created successfully');
            onSuccess?.();
        },
        onError: (error: any) => {
            const message = error?.response?.data?.detail || error?.response?.data?.message || error?.message || 'Failed to create plan';
            sendNotification('error', message);
        },
    });

    return {
        mutate,
        isPending,
    };
};

export default useCreatePlanMutation;
